import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import type { NormalizedCacheObject } from "@apollo/client";

export function createCmsClient(
    endpoint: string,
): ApolloClient<NormalizedCacheObject> {
    return new ApolloClient({
        link: new HttpLink({ uri: endpoint }),
        cache: new InMemoryCache(),
    });
}
